import React from 'react';

const DepositsSumPercent = () => {
    return (
        <div>

        </div>
    )
}

export default DepositsSumPercent;